import { api } from 'api';
import StarMarkedIcon from 'assets/icons/star-marked-icon.svg';
import StarOutlineIcon from 'assets/icons/star-outline-icon.svg';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { Fade } from 'helpers/animation';
import { checkMaintenance } from 'helpers/maintenance';
import useAuth from 'hooks/useAuth';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputFavoriteCheckbox = ({ id, isChecked }) => {
  const { token } = useAuth();

  const handleOnChange = (e) => {
    const { checked } = e.target;

    try {
      api.setFavorited(token, id, checked);
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);
    }
  };

  return (
    <FormCheckStyled
      type="checkbox"
      label=""
      defaultChecked={isChecked}
      onChange={handleOnChange}
      readOnly={true}
      onClick={(e) => {
        e.stopPropagation();
      }}
    />
  );
};

const FormCheckStyled = styled(Form.Check)`
  margin: 0;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-left: 24px;
    margin-inline: 0px;
    margin-bottom: 4px;
  }

  label {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-grey-dark);
    margin-left: 5.5px;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  input:checked[type='checkbox'] {
    background-image: url(${StarMarkedIcon});
  }

  input {
    border: none;
    border-radius: 2px;
    background-image: url(${StarOutlineIcon});
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-color: transparent;

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }
`;

export default FormInputFavoriteCheckbox;
